import { PayloadAction } from '@reduxjs/toolkit';

import { GalleryState } from 'editor/src/store/gallery/types';
import createUploadRankLookup from 'editor/src/store/gallery/utils/createUploadRankLookup';
import getUploadKey from 'editor/src/store/gallery/utils/getUploadKey';

const setUploadOrderReducer = (state: GalleryState, action: PayloadAction<string[]>) => {
  const batch = action.payload;
  const batchIds = new Set(batch);
  // Earlier batches are kept: a page of a long upload that reports after another batch started still joins
  // its own batch.
  state.uploadBatches = [
    batch,
    ...(state.uploadBatches ?? []).map((ids) => ids.filter((id) => !batchIds.has(id))).filter((ids) => ids.length),
  ];

  // Files whose preview arrived before the upload started are listed already; move them into place.
  const getRank = createUploadRankLookup(batch);
  const batchImages = state.images
    .filter((image) => getRank(getUploadKey(image)) !== undefined)
    .sort((a, b) => (getRank(getUploadKey(a)) ?? 0) - (getRank(getUploadKey(b)) ?? 0));
  if (!batchImages.length) {
    return;
  }

  state.images = [...batchImages, ...state.images.filter((image) => getRank(getUploadKey(image)) === undefined)];
};

export default setUploadOrderReducer;
